import {EmptyState, Spinner} from "@shopify/polaris";

export const EmptyStateWithSpinner = ({
    loading = false,
    content = "There are no results matching your search.",
    heading = null,
    action = null,
}) => <EmptyState
    heading={heading}
    action={action}
>
    { loading && (<Spinner size={"large"} />)}
    { !loading && (content)}
</EmptyState>


export const getValue = (val, def) => {
    if (val && val.length) {
        return val;
    }

    if (def && def.length) {
        return def;
    }

    return null;
}
